/* global jQuery */
import $ from 'jquery';
import objectFitImages from 'object-fit-images';
import 'jquery-once';
// import drupal_once from "@drupal/once";
import debounce from './modules/utils/debounce';
import WindowPopup from './modules/utils/window-popup';
import ClipboardJS from './modules/utils/clipboard.min';
import MarkJS from './modules/utils/jquery.mark.min';
import Ps from './modules/utils/perfect-scrollbar.min';
import ResizeSensor from './modules/utils/resize-sensor';
import StickySidebar from './modules/utils/jquery.sticky-sidebar.min';
import Slick from './modules/utils/slick';

// Relative Imports
import Accordion from '../../stories/components/accordion/accordion';
import BackToTop from '../../stories/components/back-to-top/back-to-top';
import BoxedText from '../../stories/components/boxed-text/boxed-text';
import CardBlock from '../../stories/objects/card-block/card-block';
import CaseStudy from '../../stories/components/case-study/case-study';
import ChapterNav from '../../stories/components/chapter-nav/chapter-nav';
import Citation from '../../stories/components/citation/citation';
import ContentFromEditor
  from '../../stories/objects/content-from-editor/content-from-editor';
import Footer from '../../stories/components/footer/footer';
import FullHeight from './modules/full-height';
import Header from '../../stories/components/header/header';
import InPageSearch
  from '../../stories/components/in-page-search/in-page-search';
import MegaMenu from '../../stories/components/mega-menu/mega-menu';
import ResourceAccordion
  from '../../stories/components/resource-accordion/resource-accordion';
import RotatingCard
  from '../../stories/components/rotating-card/rotating-card';
import ShareLinks from '../../stories/components/share-links/share-links';
import FadeInScroll from "./modules/fade-in-scroll";
import SearchFilters
  from '../../stories/components/search-filters/search-filters';
import SearchLayout from '../../stories/groups/search-layout/search-layout';
import SortingRadios
  from '../../stories/components/sorting-radios/sorting-radios';
import SearchFiltersModal
  from '../../stories/components/search-filters-modal/search-filters-modal';
import SearchModalFilters
  from '../../stories/components/search-modal-filters/search-modal-filters';
import SearchActiveFilters
  from '../../stories/components/search-active-filters/search-active-filters';

export function globalJS() {

  /**
   * Accordion
   */
  new Accordion($(document), [], $);

  /**
   * Back to top
   */
  new BackToTop($(document), [], $);

  /**
   * Boxed text
   */
  new BoxedText($(document), [], $);
  /**
   * Card block
   */
  new CardBlock($(document), [], $);

  /**
   * Case study
   */
  new CaseStudy($(document), [], $, Slick);

  /**
   * Chapter nav
   */
  new ChapterNav($(document), [], $, debounce, Ps);

  /**
   * Citation
   */
  new Citation($(document), [], $, ClipboardJS, '.js-citation-button');

  /**
   * Content from editor
   */
  new ContentFromEditor($(document), [], $);

  /**
   * Fade in scroll
   */
  new FadeInScroll();

  /**
   * Filters
   * filters.js is generated as its own file in order to run through Drupal behaviors
   */
  // new Filters($(document), [], $, debounce);

  /**
   * Footer
   */
  new Footer($(document), [], $, debounce);

  /**
   * Full height CSS
   */
  new FullHeight();

  /**
   * Header
   */
  new Header($(document), [], $, debounce);

  /**
   * In page search
   */
  new InPageSearch($(document), [], $, debounce, MarkJS, StickySidebar, ResizeSensor);

  /**
   * Mega menu
   */
  new MegaMenu($(document), [], $, debounce);

  // console.log(drupal_once);
  //
  // const megamenu = drupal_once('mega_menu', '.js-mega-menu');
  //
  // console.log(megamenu);
  // // Loop through the found elements (the things that match the selector in Param 2).
  // megamenu.forEach((element) => {
  //     // Trigger our class for each element
  //     // - Param 1 - Pass jQuery to the class
  //     // - Param 2 - The single element from our for each loop.
  //     new MegaMenu($, element, debounce);
  // });

  /**
   * Resource accordion
   */
  new ResourceAccordion($(document), [], $);

  /**
   * Rotating cards
   */
  new RotatingCard($(document), [], $);

  /**
   * Search active filters
   */
  new SearchActiveFilters($(document), [], $);

  /**
   * Search filters
   */
  new SearchFilters($(document), [], $, debounce);

  /**
   * Search filters modal
   */
  new SearchFiltersModal($(document), [], $, debounce);

  /**
   * Search modal filters
   */
  new SearchModalFilters($(document), [], $, debounce);

  /**
   * Search layout
   */
  new SearchLayout($(document), [], $, debounce);

  /**
   * Share links
   */
  new ShareLinks($(document), [], $, WindowPopup, '.js-social-share');

  /**
   * Sorting radios
   */

  new SortingRadios($(document), [], $);

  /**
   * Object fit polyfill
   */
  objectFitImages();

};

globalJS();
